module.exports = __webpack_public_path__ + "static/upgrade-6596c6f3e07b3ad2706fe2cc25acf4ec.svg";